// Author liang gang qiang
// Date 2021-10-20 09:13:43

class MintalMesPrdCraft {
constructor({
        id = null,
        parentId = '',
        name = '',
        code = '',
        level = '',
        nodeCode = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.code = code;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdCraft();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraft.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    parentIdFilter : "",
    nameFilter : "",
    codeFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.mintal.prd.mintalMesPrdCraft.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'level',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.level',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCode',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.nodeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraft.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdCraft, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
